import { priorityLabels } from "@p0security/shared/assessment/constants";
import { MonitorPriority } from "@p0security/shared/types/assessment/monitor";
import { Flex, Skeleton, Spacing } from "@p0security/ui";
import { widetype } from "@p0security/util/collections";
import { priorityColor } from "components/Assessment/utils/monitor";
import { useCallback } from "react";
import { colors } from "styles/variables";

import { MonitorPriorityCounts } from "../types";
import { FilterStatistic } from "./common/FilterStatistic";

export const OpenFindings: React.FC<{
  monitorsByPriority: MonitorPriorityCounts;
  isLoading: boolean;
  handleChange: (value: MonitorPriority) => void;
  priorities: Set<MonitorPriority>;
}> = ({ isLoading, handleChange, priorities, monitorsByPriority }) => (
  <Spacing asChild mt="1em" ml="1em">
    <Flex className="w-[30%] max-w-[20em]" gap={8} justify="center" vertical>
      {widetype.entries(priorityColor).map(([priority]) => {
        return isLoading ? (
          <Spacing asChild key={priority} mt=".5em">
            <Skeleton.Input active />
          </Spacing>
        ) : (
          <Finding
            key={priority}
            priority={priority}
            count={monitorsByPriority[priority].totalCount}
            handleClick={handleChange}
            selected={priorities.has(priority)}
          />
        );
      })}
    </Flex>
  </Spacing>
);

const Finding: React.FC<{
  priority: MonitorPriority;
  handleClick: (value: MonitorPriority) => void;
  selected: boolean;
  count: number;
}> = ({ priority, handleClick, selected, count }) => {
  const { color } = priorityColor[priority];
  const onClick = useCallback(() => {
    handleClick(priority);
  }, [handleClick, priority]);
  return (
    <FilterStatistic
      category={priorityLabels[priority]}
      color={color}
      count={count}
      selected={selected}
      textColor={colors.neutral["00"]}
      onClick={onClick}
      showEye={true}
    />
  );
};
